<template>
    <div>
        <modal-fullpage
            v-show="isPersonaModalVisible"
            @close="closePersonaModal"
            class="modal--profile modal--persona-selector"
        >
            <template v-slot:content>
                <div class="choice-options">
                    <a v-for="(persona, index) in data.personas"
                        @mouseover="itemHoverIn(index)"
                        @mouseout="itemHoverOut()"
                        data-category="Persona" data-action="Click" :data-label="persona.title"
                        :class="{blured : (hoveredItem!==null && hoveredItem!==index)}"
                        :key="index" class="choice" :href="persona.link" :style="{ backgroundImage: 'url(' + persona.image + ')' }">
                        <div class="label">I'm <span>{{persona.title}}</span></div>
                        <div class="label">{{data.summary}}</div>
                    </a>
                </div>
            </template>
        </modal-fullpage>
    </div>
</template>

<script>

// import { Fragment } from 'vue-fragment';
import ModalFullpage from './Modal/ModalFullpage'

export default {
    name: "persona-full",
    components: {
        // Fragment,
        ModalFullpage
    },
    props: {
        data: {
            type: Object
        }
    },
    data () {
        return {
            isPersonaModalVisible: false,
            hoveredItem: null
        }
    },
    methods: {
        showPersonaModal() {
            const body = document.body;
            body.classList.add("fs-modal-visible");

            this.isPersonaModalVisible = true;
        },
        closePersonaModal() {
            // const body = document.body;
            // body.classList.remove("fs-modal-visible");

            this.isPersonaModalVisible = false;
        },
        itemHoverIn(index){
            this.hoveredItem = index;
        },
        itemHoverOut(){
            this.hoveredItem = null;
        }
    }
};
</script>

<style lang="scss">
.modal--persona-selector {
    .container--body {
        @media (min-width:992px) {
            padding-left: 0;
            padding-right: 0;
        }
    }
}
</style>
